import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import InventarioModel from "@/models/inventarioModel";
import InventarioService from "@/services/inventarioService";

import ListComponentBase from "../listComponentBase";

@Component
export default class InventarioListComponent extends ListComponentBase<InventarioModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("dataCriacao", "Data", GridColumnType.Date),
            new GridColumn("tipoInventarioDescricao", "Tipo de Inventario", GridColumnType.String),
            new GridColumn("usuarioDescricao", "Usuario", GridColumnType.String),
            new GridColumn("statusDescricao", "Status", GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setProps(new InventarioService(), "inventario", "dataCriacao", false, "desc");
    }
}
